import React, { Component } from 'react';
import Chart from "react-apexcharts";

class RamChart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options: {
                chart: {
                    height: 250,
                    type: 'radialBar',
                },
                colors: ['#42DEB0'],
                plotOptions: {
                    radialBar: {
                        hollow: {
                            size: '70%',
                        }
                    },
                },
                labels: ['RAM'],
            },
            series: [props.ramPercentage],
        };
    }
    render() {
        return (
            <div>
                <Chart
                    options={this.state.options}
                    series={this.state.series}
                    type="radialBar"
                    height="200px"
                />
            </div>
        );
    }
}

export default RamChart;
